import { Component, Input, OnInit } from '@angular/core';

import { IProductAllergen } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'product-allergens',
  template: `
    <div class="font-sm" *ngIf="allergens?.length">
      <span [translate]="'productsList.productCard.allergens'">Allergens</span>:
      <span class="text-muted">{{ allergensString }}</span>
    </div>
  `
})
export class ProductAllergensComponent implements OnInit {
  @Input() allergens: IProductAllergen[];

  allergensString: string;

  constructor() { }

  ngOnInit() {
    this.allergensString = this._getAllergensString(this.allergens);
  }

  private _getAllergensString(allergens: IProductAllergen[]): string {
    return allergens
      .filter(allergen => !allergen.showAsChild)
      .map(allergen => allergen.name.toLowerCase()).join(', ');
  }

}
